import {IconRetry} from '@wandb/weave/components/Icon';
import React, {type JSX} from 'react';

import {AccountIconLocation} from '../../../pages/Billing/AccountSettings/AccountIcon';
import {AccountSelectorAccountInfo} from './AccountSelectorAccountInfo';
import * as S from './ProfileMenu.styles';
import {type Account} from './types';

type AccountSelectorMenuItemProps = {
  account: Account | null;
  isSelectedAccount: boolean;
  maxWidth?: string;
};

export function AccountSelectorMenuItem({
  account,
  isSelectedAccount,
  maxWidth,
}: AccountSelectorMenuItemProps): JSX.Element {
  if (account == null) {
    return <></>;
  }
  return (
    <>
      <S.ProfileMenuAccountContainer data-test={account?.name}>
        <AccountSelectorAccountInfo
          account={account}
          isSelectedAccount={isSelectedAccount}
          location={AccountIconLocation.ProfileMenu}
          maxWidth={maxWidth}
        />
      </S.ProfileMenuAccountContainer>
      {!isSelectedAccount && (
        <S.ProfileMenuRetryIcon>
          <IconRetry role="presentation" />
        </S.ProfileMenuRetryIcon>
      )}
    </>
  );
}
